import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({

  paragraphRow: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  number: {
    width: '5%', // reserve small width for number
    fontWeight: 'bold',
  },
  content: {
    width: '95%', // rest for content
    textAlign: 'justify',
  },
  signatureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 30,
  },
});

const PensionFormBPart3 = ({ result }) => (
  <View size="A4" style={style.page}>
    <Text style={[style.title, style.ArialBold]}>PART - II</Text>
    <Text style={[style.title, style.ArialBold]}>ACKNOWLEDGEMENT</Text>


      <AutoText >Received from             {result.employeeName} </AutoText>
      <Text >
      application in Part I of form A/form B for the commutation of a fraction of pension without medical examination.
      </Text>


    {/* Place and Signature */}
    <View style={[styles.signatureRow, {marginTop: 50}]}>
      <Text>Place: {result.placeOfRetirement}</Text>
      <Text style={style.signature}>Head of Office</Text>

    </View>

    <Text style={{ marginTop: 10 }}>Date:</Text>

  </View>
);

export default PensionFormBPart3;
